{
  "yes": "Yes",
  "no": "No",
  "ok": "Ok",
  "cancel": "Cancel",
  "messages": {
    "confirmCloseWarning": "The changes made will not be saved. Do you want to continue?"
  }
}
